import React from "react";

import { Box, Text } from "flicket-ui";
import { SlateRenderer } from "~components";
import { MembershipQuery } from "~graphql/sdk";
import Image from "~components/common/Image";
import useDescriptionText from "~hooks/useDescriptionText";

type InformationProps = {
  venue?: MembershipQuery["membership"]["venue"];
  description?: any;
  descriptionImage?: MembershipQuery["membership"]["descriptionImage"];
};

export const Information = ({
  description,
  descriptionImage,
}: InformationProps) => {
  const descriptionText = useDescriptionText(description);
  return (
    <Box maxW="800px" w="100%">
      {description ? (
        <Box mb={-1 as any}>
          <SlateRenderer mb={3} value={description} />
          {descriptionImage && (
            <Image
              image={descriptionImage}
              alt={descriptionText}
              mx={"auto" as any}
            />
          )}
        </Box>
      ) : (
        <Text mb={{ _: 1, md: 2 }}>Description coming soon!</Text>
      )}
    </Box>
  );
};
